// extracted by mini-css-extract-plugin
export default {"aurora-container":"Aurora_aurora-container__vBrw3"};